// reducers.js
import * as actionTypes from './actionTypes';
import {FORGOT_PASSWORD_SUCCESS} from "../ForgotPassword/action";
const initialState = {
  token: null,
  error: null,
  isLogin: false
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isLogin: true,
        token: action.token,
        error: false,
      };
    case actionTypes.LOGIN_FAILURE:
      return {
        ...state,
        isLogin: false,
        error: action.error,
      };
    case actionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        isLogin: false,
        token: null,
        error: null,
      };
      case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export default authReducer;
